import React, { useEffect, useState } from "react";
import "./crisismanagementtools.scss";
import { Button, Typography, Input, message, Form, DatePickerProps, DatePicker } from "antd";
import DataTableOtherContent from "../../components/dataTable/DataTableOtherContent";
import { otherVideoContentsSVC } from "../../services";
import ReactQuill from "react-quill";
import moment from "moment";
import dayjs from "dayjs";
import useSWR from "swr";
import axios from "axios";
import * as Cookie from "universal-cookie";
import { AppModal, AppUpload } from "../../components/common";

const cookie = new Cookie.default();
const cachedToken = cookie.get("userAuthTokenAdmin");

const { Text } = Typography;

interface Contentdata {
  key?: string;
  id: number;
  title: string;
  type: string;
  contend: string;
  link: string;
  image: string;
  sheduledDate: string;
}

const fetcher = (url: any) =>
  axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${cachedToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => res?.data);

function CrisisManagementTools() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [editContent, setEditContent] = useState<any>({
    _id: "",
    id: "",
    title: "",
    contend: "",
    link: "",
    image: "",
    sheduledDate: null,
  });
  // const [contentData, setContentData] = useState<Contentdata[]>([]);
  const [uploadedImage, setUploadedImage] = useState<any>(null);
  const [loading, setloading] = useState<boolean>(false);
  const [btnDisable, setBtnDisable] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  const { data: contentData, mutate: getOtherContent } = useSWR(
    API_URL + "/times/video-contents/",
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  const filteredData = contentData
    ?.filter((item: any) => item?.type === "crisis")
    ?.map((item: any) => ({
      ...item,
      contend: item.description ?? item.contend,
      link: item.url ?? item.link,
      image: item.url ?? item.image,
    }));

  const deleteOtherContent = (id: string) => {
    otherVideoContentsSVC
      .deleteLatestVideos(id)
      .then((res: any) => {
        getOtherContent();
        message.success("Deleted Successfully");
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const updateOtherContent = (id: string) => {
    setloading(true);
    const formData: any = new FormData();
    formData.append("title", editContent.title);
    formData.append("type", "crisis");
    formData.append("description", editContent.contend);
    formData.append("video", editContent.image instanceof File ? editContent.image : (editContent.link || editContent.url || ""));
    if (editContent.sheduledDate !== null) {
      formData.append("sheduledDate", editContent.sheduledDate);
    } else {
      formData.append("sheduledDate", moment().format("YYYY-MM-DD"));
    }

    otherVideoContentsSVC
      .updateLatestVideos(id, formData)
      .then((res: any) => {
        setloading(false);
        getOtherContent();
        message.success("Updated Successfully");
        handleCancel();
      })
      .catch((err: any) => {
        message.error(err.message);
        setloading(false);
      });
  };
  const addOtherContent = () => {
    setloading(true);
    const formData: any = new FormData();
    formData.append("title", editContent.title);
    formData.append("type", "crisis");
    formData.append("description", editContent.contend);
    formData.append("video", editContent.image instanceof File ? editContent.image : (editContent.link || editContent.url || ""));
    if (editContent.sheduledDate !== null) {
      formData.append("sheduledDate", editContent.sheduledDate);
    } else {
      formData.append("sheduledDate", moment().format("YYYY-MM-DD"));
    }

    otherVideoContentsSVC
      .addLatestVideos(formData)
      .then((res: any) => {
        setloading(false);
        getOtherContent();
        message.success("Added Successfully");
        setEditContent({
          _id: "",
          id: "",
          title: "",
          image: "",
          contend: "",
          link: "",
          sheduledDate: null,
        });
        setUploadedImage(null);
        handleCancel();
      })
      .catch((err: any) => {
        message.error(err.message);
        setloading(false);
      });
  };
  const editOtherContent = (id: string) => {
    otherVideoContentsSVC
      .editLatestVideos(id)
      .then((res: any) => {
        const data = res.data?.data ?? res.data;
        setEditContent({
          _id: data._id ?? data.id,
          id: data.id ?? data._id,
          title: data.title,
          contend: data.description ?? data.contend,
          link: data.url ?? data.link,
          image: data.url ?? data.image,
          sheduledDate: data.sheduledDate,
        });
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const showModal = () => {
    handleCancel();
    setIsModalOpen(true);
    setIsEditable(false);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditContent({
      _id: "",
      id: "",
      title: "",
      image: "",
      contend: "",
      link: "",
      sheduledDate: null,
    });
    setUploadedImage(null);
    setloading(false);
  };

  const handleFileUpload = async (event: any) => {
    event.preventDefault();
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setUploadedImage(reader.result);
    };
    setBtnDisable(false);
    setEditContent((prevData: any) => ({
      ...prevData,
      image: file,
    }));

    reader.readAsDataURL(file);
  };
  const handleInputChange = (event: any) => {
    setBtnDisable(false);
    const { name, value } = event.target;
    setEditContent((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleDescription = (value: any) => {
    setBtnDisable(false);
    setEditContent((prevData: any) => ({
      ...prevData,
      contend: value,
    }));
  };

  const onChange: DatePickerProps["onChange"] = (date, dateString) => {
    setBtnDisable(false);
    setEditContent((prevData: any) => ({
      ...prevData,
      sheduledDate: date,
    }));
  };
  return (
    <div className="contentBox">
      <div className="info">
        <Text className="title24">Crisis Management Tools</Text>
      </div>
      <DataTableOtherContent
        deleteOtherContent={deleteOtherContent}
        editContent={editOtherContent}
        setshowModel={setIsModalOpen}
        setEditable={setIsEditable}
        isOpen={isModalOpen}
        contentData={filteredData}
        showModal={showModal}
      />
      <AppModal
        title={
          isEditable === true
            ? "Update Crisis Management Tools"
            : "Add Crisis Management Tools"
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Input
          className="input"
          name="title"
          onChange={handleInputChange}
          size={"large"}
          style={{ marginBottom: "16px" }}
          value={editContent.title}
          placeholder={"Enter Title"}
        />
        {editContent.title === "" ? null : (
          <>
            <DatePicker
              value={
                editContent.sheduledDate
                  ? dayjs(editContent.sheduledDate)
                  : null
              }
              disabledDate={(current) => {
                return current && current < moment().startOf("day");
              }}
              style={{ width: "100%", marginBottom: "16px" }}
              onChange={onChange}
            />
          </>
        )}
        {editContent.title === "" ? null : (
          <>
            <ReactQuill
              style={{ marginBottom: "16px" }}
              value={editContent.contend}
              onChange={handleDescription}
              modules={{
                toolbar: [
                  [{ header: "1" }, { header: "2" }],
                  ["bold", "italic", "underline", "strike", "blockquote"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link"],
                  ["clean"],
                ],
              }}
            />
          </>
        )}
        {editContent.contend === "" ? null : (
          <>
            <Input
              type="url"
              name="link"
              onChange={handleInputChange}
              size={"large"}
              style={{ marginBottom: "16px" }}
              value={editContent.link}
              placeholder={"Enter Link"}
            />
          </>
        )}
        {editContent.link === "" ? null : (
          <>
            <AppUpload
              kind="video"
              image={typeof editContent?.image === "string" ? editContent.image : undefined}
              uploadedImage={uploadedImage}
              handleFileUpload={handleFileUpload}
            />
          </>
        )}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={() => {
              if (editContent.title === "") {
                setBtnDisable(true);
                message.info("Please Enter title");
              } else if (editContent.sheduledDate === null) {
                setBtnDisable(true);
                message.info("Please Enter Date");
              } else if (editContent.contend === "") {
                setBtnDisable(true);
                message.info("Please Enter Content");
              } else if (editContent.link === "") {
                message.info("Please Enter link");
              } else {
                if (isEditable === true) {
                  updateOtherContent(editContent._id || editContent.id || "");
                } else {
                  if (editContent.image === "") {
                    setBtnDisable(true);
                    message.info("Please upload a video");
                  } else {
                    addOtherContent();
                  }
                }
              }
            }}
            style={{
              marginTop: "16px",
            }}
            className="button"
            loading={loading}
            disabled={btnDisable ? true : false}
          >
            {isEditable === true ? "Update " : "Add"}
          </Button>
        </div>
      </AppModal>
    </div>
  );
}

export default CrisisManagementTools;
